export default {"src":"/_next/static/media/reach_icon_rgb_white.f5f30c43.svg","height":203,"width":203,"blurWidth":0,"blurHeight":0};